import request from "../utils/request"

export function fetchAdminPlanOverview() {
  return request({
    url: "/admin/plans/overview",
    method: "get"
  })
}

export function fetchAdminPlans(params = {}) {
  return request({
    url: "/admin/plans",
    method: "get",
    params
  })
}
